var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.accordionClasses },
    _vm._l(_vm.items, function(item) {
      return _c("span", [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "dropdown icon" }),
          _vm._v("\n            " + _vm._s(item.title) + "\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [_vm._v(_vm._s(item.content))])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66f2dc00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f2dc00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Accordion.vue
// module id = 3UTd
// module chunks = 1